import React, { useEffect, useState } from "react";
import { MembersContainer } from "../../styled/scheduler";
import { useSelector } from "react-redux";
import axios from "axios";
import { useRegex } from "../../../../../../hooks/useRegex";

const Members = ({ eventInfo }) => {
  const user = useSelector((state) => state?.user?.data[0]);
  const [member, setMember] = useState({ manager: null, workers: [], author: null });
  const { TelFormat } = useRegex();

  useEffect(() => {
    getMembers();
  }, [eventInfo]);

  const getMembers = async () => {
    const url = "/api/mbers";
    const body = Array.from(
      new Set(
        [
          ...Object.keys(eventInfo.workerList || {}),
          eventInfo.managerNo && String(eventInfo.managerNo),
          eventInfo.mberNo && String(eventInfo.mberNo),
        ].filter(Boolean),
      ),
    );

    const res = await axios.post(url, body);

    console.log(eventInfo);
    console.log(res);
    if (!Array.isArray(res.data)) return;

    setMember({
      manager: {
        ...(res.data.find((m) => String(m.mberNo) === String(eventInfo.managerNo)) ||
          res.data.find((m) => String(m.mberNo) === String(eventInfo.mberNo)) ||
          {}),
      },
      workers: eventInfo.workerList
        ? Object.entries(eventInfo.workerList).map(([mberNo, mberNm]) => {
            const workerData = res.data.find((m) => String(m.mberNo) === mberNo) || {};
            return {
              ...workerData,
              mberNo,
              mberNm,
            };
          })
        : [],
    });
  };

  const isUser = (mberNo) => (user?.mberNo?.toString() === mberNo?.toString() ? "active" : "");

  return (
    <MembersContainer className="members">
      {member.manager && (
        <div className="section">
          <p>{eventInfo.gbn === "C" ? "담당자" : eventInfo?.gbn === "P" ? "작성자" : "주최자"}</p>
          <div className="manager">
            <img src={imgHandler(member.manager.imgPath) || "/img/user2.png"} alt="manager" />
            <div className="info">
              <span className={isUser(member.manager.mberNo)}>{member.manager.mberNm}</span>
              <span>{TelFormat(member.manager.moblphonNo)}</span>
            </div>
          </div>
        </div>
      )}
      <div className="section">
        {member.workers.length > 0 && <p>{eventInfo?.gbn === "C" ? "실무자" : "참여자"}</p>}
        <ul>
          {member.workers.map((worker) => (
            <li key={worker.mberNo}>
              <img src={imgHandler(worker.imgPath) || "/img/user2.png"} alt="worker" />
              <div className="info">
                <span className={isUser(worker.mberNo)}>{worker.mberNm}</span>
                <span>{TelFormat(worker.moblphonNo)}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </MembersContainer>
  );
};

export default Members;
